import useGetUser from 'hooks/useGetUser';
// import useGetLoadConfig from 'hooks/others/useGetLoadConfig';
import useGetCountries from 'hooks/others/useGetCountries';
import useGetVendor from 'hooks/common/useGetVendor';
import useGetBackgroundProcessEnums from 'hooks/backgroundProcess/useGetBackgroundProcessEnums';
import getUser from 'redux/selector/getUser';

const propTypes = {};

const GlobalHooks = (props) => {
  const { isLogged } = getUser();

  //! Execute when app start
  useGetUser();

  if (isLogged) {
    // useGetLoadConfig();
    useGetCountries();
    useGetVendor();
    useGetBackgroundProcessEnums();
  }

  return null;
};

GlobalHooks.propTypes = propTypes;
export default GlobalHooks;
